// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_4.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
}

body {
  width: 100%;
  height: 100%;
  position: relative;
}

#main-resto_list {
  max-width: 80%;
  margin: 2rem auto;
}
button,
a,
input,
.btn {
  box-sizing: border-box;
  min-width: 44px;
  min-height: 44px;
}

#loadingIndicator {
  text-align: center;
  width: 3rem;
  height: 3rem;
  border: 1.5em solid transparent;
  border-top-color: red;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.skip2content {
  background-color: black;
  border-radius: 4px;
  color: black;
  font-weight: 500;
  left: 0;
  line-height: 44px;
  margin: 0 auto;
  padding: 0 10px;
  position: absolute;
  right: 0;
  top: -50px;
  transition: 0.35s;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 1500;
}

.skip2content:focus {
  top: 30px;
}

header {
  top: 0;
  position: sticky;
  z-index: 100;
}

/*
  NAVBAR
*/

.app-bar {
  padding: 8px 16px;
  background-color: black;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  position: sticky;
  top: 0;
  z-index: 99;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.app-bar .app-bar__menu {
  display: flex;
  align-items: center;
}

#hamburgerButton {
  color: white;
}
.app-bar .app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
}

.app-bar .app-bar__brand {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__brand a {
  color: #faf7f7;
  text-transform: uppercase;
  font-size: 1.8rem;
  font-weight: bold;
  user-select: none;
}

.app-bar .app-bar__navigation {
  position: absolute;
  top: 50px;
  left: -180px;
  width: 150px;
  transition: all 0.3s;
  padding: 8px;
  background-color: black;
  overflow: hidden;
}

.app-bar .app-bar__navigation.open {
  left: 0;
}

.app-bar .app-bar__navigation ul li a {
  display: inline-block;
  text-decoration: none;
  color: white;
  padding: 8px;
  margin-bottom: 5px;
  width: 100%;
  text-transform: uppercase;
}

/* 
  hero
*/

.hero-container {
  min-height: 380px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hero-container .hero-content-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.hero-container .hero-content-container > h1,
p {
  font-weight: bold;
  line-height: 2em;
}
.hero-text {
  text-align: center;
  color: white;
}

/*
  Main Content
*/

section {
  margin-top: 40px;
}

a,
p,
h1,
h2,
h3,
h4 {
  text-decoration: none;
}

.main-resto_container {
  margin: 60px auto;
}

.main-resto_label {
  margin: auto;
  width: max-content;
  font-size: 22px;
}

.main-resto_label hr {
  margin-top: 0;
  width: 50%;
  border-bottom: 1px solid #9ac8cd;
}

.list-resto {
  margin-top: 2rem;
  text-align: left;
  display: grid;
  grid-gap: 16px;
}

.resto-item {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  top: 0;
  transition: top ease 0.4s;
  cursor: pointer;
}

.resto-item:hover {
  top: -4px;
}

.resto-title {
  display: inline-block;
  justify-content: space-between;
}

.resto-item_image {
  object-fit: cover;
  width: 100%;
  height: 250px;
}

.resto-item_name {
  font-weight: bold;
  font-size: 24px;
  margin-top: 6px;
  transition: 0.3s opacity;
  padding: 0 16px 0 16px;
  text-align: center;
  text-transform: uppercase;
}

.resto-item_city {
  position: absolute;
  text-transform: uppercase;
  top: 8px;
  left: 16px;
  border-radius: 5px;
  background-color: #0e46a3;
  padding: 5px 10px 5px;
  color: #e1f7f5;
  font-weight: 500;
}

.resto-item_rating {
  color: black;
  font-weight: 600;
  text-decoration: none;
  margin: 0 0 0 5px;
  padding: 5px 10px 5px;
  border-radius: 5px;
  color: #e1f7f5;
  background-color: #0e46a3;
}

.resto-item_name:hover {
  opacity: 0.7;
}

.resto-item_name {
  text-decoration: none;
  color: black;
  font-size: 24px;
}

.resto-item_desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 16px 15px;
  font-size: 14px;
  line-height: 1.5em;
  color: black;
}

/* 
  DETAIL
*/
.explore-restaurant__label {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #1e0342;
}

.explore-restaurant__label::after {
  content: "";
  margin-top: 16px;
  display: block;
  border-bottom: 3px solid #1e0342;
}

.img-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.resto-item_image-container {
  max-width: 600px;
}

/* 
  detail ifon
*/
.detail-info {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 2rem;
  max-width: 80%;
}

.detail-info h4 {
  padding-top: 20px;
  color: #1e0342;
  font-size: 1.5em;
  margin: 0;
  text-align: left;
}

.detail-info li {
  color: #1e0342;
  position: relative;
  display: block;
  margin-top: 10px;
}

.resto-name {
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
}

.detail-name-address-rating {
  display: inline-block;
  margin: 0;
}

.resto-address,
.resto-rating,
.resto-category {
  font-size: 18px;
  margin: 0;
  text-align: left;
}

.detail-desc {
  text-align: justify;
  color: black;
  margin-bottom: 0.5em;
  margin: 0;
  font-size: 14px;
  line-height: 1.5em;
  font-weight: 400;
}

.category {
  padding: 0.3em 1em;
  color: #e1f7f5;
  background-color: #1e0342;
  margin-right: 2px;
  border: 1px solid transparent;
  border-radius: 5px 5px 5px 5px;
  text-align: left;
  height: 50px;
}

.restaurant-detail__category {
  border-radius: 15px;
  font-size: 12px;
  padding: 5px 20px;
  color: white;
}

/* 
  list menu detail
*/
#resto-detail-form-review-title {
  text-align: center;
  margin: 3rem;
  font-size: 2em;
}

.foods h3,
.drinks h3 {
  text-align: center;
}
.restaurant-detail__info,
.restaurant-detail__menu-list,
.restaurant-detail__review {
  margin-bottom: 5px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 50px;
  max-width: 750px;
  margin: 0 auto;
}

.foods,
.drinks {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  padding-top: 10px;
  margin: 1rem;
}

.restaurant-detail__foods > li,
.restaurant-detail__drinks > li {
  list-style: none;
  margin: 10px 15px;
  padding: 1px;
  color: black;
  text-align: left;
}

/* Detail Review */

.detail-review {
  text-align: left;
  display: grid;
  grid-gap: 16px;
  max-width: 100%;
  font-size: 1em;
  margin: 2rem;
}

.detail-review-item {
  color: #e1f7f5;
  background-color: #0e46a3;
  box-shadow: rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border-radius: 2em;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  padding: 10px;
}
.bi-person-circle {
  font-size: 4rem; /* Ukuran ikon */
  color: #9ac8cd;
  grid-row: span 2;
  text-align: center;
}

.name-review {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

.date-review {
  font-size: 14px;
  color: #9ac8cd;
  margin: 5px 0;
}

.body-review {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 0.5em;
}

/* FORM */
form {
  margin: 0 auto 2em;
  padding: 1.5em;
  width: 50%;
  border: 3px solid #1e0342;
  border-radius: 15px;
}

.form-control {
  display: block;
  width: 100%;
  height: 60px;
  padding: 0.738em;
  font-size: 1.37em;
  color: #1e0342;
  background-color: #9ac8cd;
  border: 1px solid #1e0342;
  border-radius: 1em;
}

.form-label {
  display: block;
  font-size: 1.3em;
  margin-bottom: 0.5em;
  text-align: left;
  color: #1e0342;
}

.mb-3 {
  margin-bottom: 1.3em;
  margin-top: 0.5em;
}

.btn {
  display: inline-block;
  width: 100px;
  height: 50px;
  font-size: 1em;
  font-weight: bold;
  color: white;
  background-color: #0e46a3;
  border: 2px solid #1e0342;
  border-radius: 1em;
}

.btn:hover {
  box-shadow: 0px 10px 13px -7px #1e0342, 5px 5px 15px 5px #1e0342;
  background-color: #0e46a3;
}

/*
  Like
*/
.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #db0000;

  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;

  font-size: 18px;
  color: white;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AACA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;;;EAIE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;EACN,gBAAgB;EAChB,YAAY;AACd;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yDAAgE;EAChE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;;;EAGE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE;0CACwC;EACxC,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kBAAkB;;AAElB;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kDAAkD;EAClD,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;AAC3B;;AAEA;;CAEC;AACD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;;EAET,eAAe;EACf,YAAY;EACZ,eAAe;AACjB","sourcesContent":["@import url(\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css\");\r\n* {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nbody {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n#main-resto_list {\r\n  max-width: 80%;\r\n  margin: 2rem auto;\r\n}\r\nbutton,\r\na,\r\ninput,\r\n.btn {\r\n  box-sizing: border-box;\r\n  min-width: 44px;\r\n  min-height: 44px;\r\n}\r\n\r\n#loadingIndicator {\r\n  text-align: center;\r\n  width: 3rem;\r\n  height: 3rem;\r\n  border: 1.5em solid transparent;\r\n  border-top-color: red;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.skip2content {\r\n  background-color: black;\r\n  border-radius: 4px;\r\n  color: black;\r\n  font-weight: 500;\r\n  left: 0;\r\n  line-height: 44px;\r\n  margin: 0 auto;\r\n  padding: 0 10px;\r\n  position: absolute;\r\n  right: 0;\r\n  top: -50px;\r\n  transition: 0.35s;\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\r\n  z-index: 1500;\r\n}\r\n\r\n.skip2content:focus {\r\n  top: 30px;\r\n}\r\n\r\nheader {\r\n  top: 0;\r\n  position: sticky;\r\n  z-index: 100;\r\n}\r\n\r\n/*\r\n  NAVBAR\r\n*/\r\n\r\n.app-bar {\r\n  padding: 8px 16px;\r\n  background-color: black;\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto;\r\n  gap: 10px;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 99;\r\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.app-bar .app-bar__menu {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n#hamburgerButton {\r\n  color: white;\r\n}\r\n.app-bar .app-bar__menu button {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 18px;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.app-bar .app-bar__brand {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.app-bar .app-bar__brand a {\r\n  color: #faf7f7;\r\n  text-transform: uppercase;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  user-select: none;\r\n}\r\n\r\n.app-bar .app-bar__navigation {\r\n  position: absolute;\r\n  top: 50px;\r\n  left: -180px;\r\n  width: 150px;\r\n  transition: all 0.3s;\r\n  padding: 8px;\r\n  background-color: black;\r\n  overflow: hidden;\r\n}\r\n\r\n.app-bar .app-bar__navigation.open {\r\n  left: 0;\r\n}\r\n\r\n.app-bar .app-bar__navigation ul li a {\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  color: white;\r\n  padding: 8px;\r\n  margin-bottom: 5px;\r\n  width: 100%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* \r\n  hero\r\n*/\r\n\r\n.hero-container {\r\n  min-height: 380px;\r\n  position: relative;\r\n  background-image: url(\"../public/images/heros/hero-image_4.jpg\");\r\n  width: 100%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n.hero-container .hero-content-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-align: center;\r\n}\r\n\r\n.hero-container .hero-content-container > h1,\r\np {\r\n  font-weight: bold;\r\n  line-height: 2em;\r\n}\r\n.hero-text {\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n/*\r\n  Main Content\r\n*/\r\n\r\nsection {\r\n  margin-top: 40px;\r\n}\r\n\r\na,\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4 {\r\n  text-decoration: none;\r\n}\r\n\r\n.main-resto_container {\r\n  margin: 60px auto;\r\n}\r\n\r\n.main-resto_label {\r\n  margin: auto;\r\n  width: max-content;\r\n  font-size: 22px;\r\n}\r\n\r\n.main-resto_label hr {\r\n  margin-top: 0;\r\n  width: 50%;\r\n  border-bottom: 1px solid #9ac8cd;\r\n}\r\n\r\n.list-resto {\r\n  margin-top: 2rem;\r\n  text-align: left;\r\n  display: grid;\r\n  grid-gap: 16px;\r\n}\r\n\r\n.resto-item {\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  top: 0;\r\n  transition: top ease 0.4s;\r\n  cursor: pointer;\r\n}\r\n\r\n.resto-item:hover {\r\n  top: -4px;\r\n}\r\n\r\n.resto-title {\r\n  display: inline-block;\r\n  justify-content: space-between;\r\n}\r\n\r\n.resto-item_image {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 250px;\r\n}\r\n\r\n.resto-item_name {\r\n  font-weight: bold;\r\n  font-size: 24px;\r\n  margin-top: 6px;\r\n  transition: 0.3s opacity;\r\n  padding: 0 16px 0 16px;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.resto-item_city {\r\n  position: absolute;\r\n  text-transform: uppercase;\r\n  top: 8px;\r\n  left: 16px;\r\n  border-radius: 5px;\r\n  background-color: #0e46a3;\r\n  padding: 5px 10px 5px;\r\n  color: #e1f7f5;\r\n  font-weight: 500;\r\n}\r\n\r\n.resto-item_rating {\r\n  color: black;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  margin: 0 0 0 5px;\r\n  padding: 5px 10px 5px;\r\n  border-radius: 5px;\r\n  color: #e1f7f5;\r\n  background-color: #0e46a3;\r\n}\r\n\r\n.resto-item_name:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.resto-item_name {\r\n  text-decoration: none;\r\n  color: black;\r\n  font-size: 24px;\r\n}\r\n\r\n.resto-item_desc {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 5;\r\n  font-weight: 500;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  margin: 16px 15px;\r\n  font-size: 14px;\r\n  line-height: 1.5em;\r\n  color: black;\r\n}\r\n\r\n/* \r\n  DETAIL\r\n*/\r\n.explore-restaurant__label {\r\n  font-size: 32px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  color: #1e0342;\r\n}\r\n\r\n.explore-restaurant__label::after {\r\n  content: \"\";\r\n  margin-top: 16px;\r\n  display: block;\r\n  border-bottom: 3px solid #1e0342;\r\n}\r\n\r\n.img-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.resto-item_image-container {\r\n  max-width: 600px;\r\n}\r\n\r\n/* \r\n  detail ifon\r\n*/\r\n.detail-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-evenly;\r\n  margin: 2rem;\r\n  max-width: 80%;\r\n}\r\n\r\n.detail-info h4 {\r\n  padding-top: 20px;\r\n  color: #1e0342;\r\n  font-size: 1.5em;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.detail-info li {\r\n  color: #1e0342;\r\n  position: relative;\r\n  display: block;\r\n  margin-top: 10px;\r\n}\r\n\r\n.resto-name {\r\n  font-size: 18px;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.detail-name-address-rating {\r\n  display: inline-block;\r\n  margin: 0;\r\n}\r\n\r\n.resto-address,\r\n.resto-rating,\r\n.resto-category {\r\n  font-size: 18px;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.detail-desc {\r\n  text-align: justify;\r\n  color: black;\r\n  margin-bottom: 0.5em;\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.5em;\r\n  font-weight: 400;\r\n}\r\n\r\n.category {\r\n  padding: 0.3em 1em;\r\n  color: #e1f7f5;\r\n  background-color: #1e0342;\r\n  margin-right: 2px;\r\n  border: 1px solid transparent;\r\n  border-radius: 5px 5px 5px 5px;\r\n  text-align: left;\r\n  height: 50px;\r\n}\r\n\r\n.restaurant-detail__category {\r\n  border-radius: 15px;\r\n  font-size: 12px;\r\n  padding: 5px 20px;\r\n  color: white;\r\n}\r\n\r\n/* \r\n  list menu detail\r\n*/\r\n#resto-detail-form-review-title {\r\n  text-align: center;\r\n  margin: 3rem;\r\n  font-size: 2em;\r\n}\r\n\r\n.foods h3,\r\n.drinks h3 {\r\n  text-align: center;\r\n}\r\n.restaurant-detail__info,\r\n.restaurant-detail__menu-list,\r\n.restaurant-detail__review {\r\n  margin-bottom: 5px;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 50px;\r\n  max-width: 750px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.foods,\r\n.drinks {\r\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\r\n    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\r\n  padding-top: 10px;\r\n  margin: 1rem;\r\n}\r\n\r\n.restaurant-detail__foods > li,\r\n.restaurant-detail__drinks > li {\r\n  list-style: none;\r\n  margin: 10px 15px;\r\n  padding: 1px;\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Detail Review */\r\n\r\n.detail-review {\r\n  text-align: left;\r\n  display: grid;\r\n  grid-gap: 16px;\r\n  max-width: 100%;\r\n  font-size: 1em;\r\n  margin: 2rem;\r\n}\r\n\r\n.detail-review-item {\r\n  color: #e1f7f5;\r\n  background-color: #0e46a3;\r\n  box-shadow: rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\r\n  border-radius: 2em;\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  grid-gap: 10px;\r\n  padding: 10px;\r\n}\r\n.bi-person-circle {\r\n  font-size: 4rem; /* Ukuran ikon */\r\n  color: #9ac8cd;\r\n  grid-row: span 2;\r\n  text-align: center;\r\n}\r\n\r\n.name-review {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.date-review {\r\n  font-size: 14px;\r\n  color: #9ac8cd;\r\n  margin: 5px 0;\r\n}\r\n\r\n.body-review {\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n  margin-bottom: 0.5em;\r\n}\r\n\r\n/* FORM */\r\nform {\r\n  margin: 0 auto 2em;\r\n  padding: 1.5em;\r\n  width: 50%;\r\n  border: 3px solid #1e0342;\r\n  border-radius: 15px;\r\n}\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  height: 60px;\r\n  padding: 0.738em;\r\n  font-size: 1.37em;\r\n  color: #1e0342;\r\n  background-color: #9ac8cd;\r\n  border: 1px solid #1e0342;\r\n  border-radius: 1em;\r\n}\r\n\r\n.form-label {\r\n  display: block;\r\n  font-size: 1.3em;\r\n  margin-bottom: 0.5em;\r\n  text-align: left;\r\n  color: #1e0342;\r\n}\r\n\r\n.mb-3 {\r\n  margin-bottom: 1.3em;\r\n  margin-top: 0.5em;\r\n}\r\n\r\n.btn {\r\n  display: inline-block;\r\n  width: 100px;\r\n  height: 50px;\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  color: white;\r\n  background-color: #0e46a3;\r\n  border: 2px solid #1e0342;\r\n  border-radius: 1em;\r\n}\r\n\r\n.btn:hover {\r\n  box-shadow: 0px 10px 13px -7px #1e0342, 5px 5px 15px 5px #1e0342;\r\n  background-color: #0e46a3;\r\n}\r\n\r\n/*\r\n  Like\r\n*/\r\n.like {\r\n  width: 55px;\r\n  height: 55px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #db0000;\r\n\r\n  position: fixed;\r\n  bottom: 16px;\r\n  right: 16px;\r\n  border-radius: 50%;\r\n  border: 0;\r\n\r\n  font-size: 18px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
